class UserEntity {
    id?: number;
    id_grup?: number;
    id_vendor?: number;
    username: string;
    rolename: string;
    vendor?: string;

    constructor(object: {
        id?: number;
        id_grup?: number;
        id_vendor?: number;
        username: string;
        rolename: string;
        vendor?: string;
    }) {
        this.id = object.id;
        this.id_grup = object.id_grup;
        this.id_vendor = object.id_vendor;
        this.username = object.username;
        this.rolename = object.rolename;
        this.vendor = object.vendor;
    }
}

class UserContextEntity {
    username: string;
    rolename: string;
    vendor?: string;

    constructor(object: {
        username: string;
        rolename: string;
        vendor?: string;
    }) {
        this.username = object.username;
        this.rolename = object.rolename;
        this.vendor = object.vendor;
    }
}

class AddUserEntity {
    id_grup?: number;
    id_vendor?: number;
    username?: string;
    rolename?: string;
    vendor?: string;

    constructor(object: {
        id_grup?: number;
        id_vendor?: number;
        username?: string;
        rolename?: string;
        vendor?: string;
    }) {
        this.id_grup = object.id_grup;
        this.id_vendor = object.id_vendor;
        this.username = object.username;
        this.rolename = object.rolename;
        this.vendor = object.vendor;
    }
}

export { UserEntity, AddUserEntity, UserContextEntity };